import React from 'react'
import PropTypes from 'prop-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import WidgetRenderer from '../WidgetRenderer/WidgetRenderer'

export default function Article(props) {
  const referencesById = {}
  props.references?.forEach(r => {
    referencesById[r.id] = r
  })

  const renderOptions = {
    renderNode: {
      [INLINES.EMBEDDED_ENTRY]: (node) => {
        if (node.data.target?.sys?.type === 'Link' && node.data.target?.sys?.linkType === 'Entry') {
          return <WidgetRenderer {...referencesById[node.data.target.sys.id]} />
        }
      },
      [BLOCKS.EMBEDDED_ENTRY]: (node) => {
        if (node.data.target?.sys?.type === 'Link' && node.data.target?.sys?.linkType === 'Entry') {
          return <WidgetRenderer {...referencesById[node.data.target.sys.id]} />
        }
      },
    },
  }

  return <>{documentToReactComponents(props.body, renderOptions)}</>
}

Article.propTypes = {
  body: PropTypes.object.isRequired,
  references: PropTypes.array,
}
